import { Plus, Building2, CalendarDays } from "lucide-react";
import { AppChrome } from "./DashboardMockup";

const columns = [
    {
        stage: "New", color: "#3B82F6", total: "₹15.7L",
        deals: [
            { company: "Skyline Constructions", value: "₹12.5L", owner: "RS", close: "Aug 12", prob: 20 },
            { company: "PeakFin Advisors", value: "₹3.2L", owner: "PN", close: "Aug 20", prob: 15 },
        ],
    },
    {
        stage: "Contacted", color: "#0EA5E9", total: "₹10.9L",
        deals: [
            { company: "Orbit Staffing", value: "₹6.8L", owner: "AT", close: "Aug 08", prob: 35 },
            { company: "GreenLeaf Agro", value: "₹4.1L", owner: "RS", close: "Aug 15", prob: 40 },
        ],
    },
    {
        stage: "Qualified", color: "#8B5CF6", total: "₹17.0L",
        deals: [
            { company: "Northwind Realty", value: "₹9.4L", owner: "PN", close: "Aug 05", prob: 50 },
            { company: "TechVista Solutions", value: "₹7.6L", owner: "RS", close: "Aug 22", prob: 45 },
        ],
    },
    {
        stage: "Proposal", color: "#F59E0B", total: "₹23.7L",
        deals: [
            { company: "Meridian Estates", value: "₹18.2L", owner: "AT", close: "Jul 30", prob: 65 },
            { company: "FinEdge Capital", value: "₹5.5L", owner: "PN", close: "Aug 02", prob: 60 },
        ],
    },
    {
        stage: "Won", color: "#16A34A", total: "₹19.5L",
        deals: [
            { company: "Apex Manufacturing", value: "₹14.6L", owner: "AT", close: "Closed", prob: 100 },
            { company: "BrightHire HR", value: "₹4.9L", owner: "PN", close: "Closed", prob: 100 },
        ],
    },
];

const PipelineScreen = () => (
    <div>
        <AppChrome active="Opportunities" />
        <div className="bg-[#F7F9FA] p-3.5 sm:p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                    <p className="font-display text-[15px] font-extrabold text-[#111827]">Sales Pipeline</p>
                    <p className="text-[10px] text-[#64748B]">Q3 · 65 open opportunities</p>
                </div>
                <div className="flex items-center gap-1.5">
                    <span className="rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[9px] font-semibold text-[#475569]">Open ₹84.5L</span>
                    <span className="hidden rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[9px] font-semibold text-[#475569] sm:block">Weighted ₹44.1L</span>
                    <span className="flex items-center gap-1 rounded-lg bg-[#16A34A] px-2 py-1 text-[9px] font-bold text-white">
                        <Plus className="h-2.5 w-2.5" /> Add Deal
                    </span>
                </div>
            </div>

            <div className="mt-2.5 flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none]">
                {columns.map((col) => (
                    <div key={col.stage} className="w-[168px] shrink-0">
                        <div className="mb-1.5 flex items-center justify-between rounded-lg bg-white px-2 py-1.5 ring-1 ring-[#EDF0F3]">
                            <span className="flex items-center gap-1.5 text-[9px] font-bold text-[#334155]">
                                <span className="h-1.5 w-1.5 rounded-full" style={{ background: col.color }} />
                                {col.stage}
                            </span>
                            <span className="text-[8px] font-bold text-[#94A3B8]">{col.total}</span>
                        </div>
                        <div className="grid gap-1.5">
                            {col.deals.map((d) => (
                                <div key={d.company} className="rounded-lg border border-[#EDF0F3] bg-white p-2.5 shadow-sm">
                                    <p className="flex items-center gap-1 truncate text-[9px] font-bold text-[#111827]">
                                        <Building2 className="h-2.5 w-2.5 shrink-0 text-[#94A3B8]" />
                                        {d.company}
                                    </p>
                                    <p className="mt-1 font-display text-[12px] font-extrabold text-[#16A34A]">{d.value}</p>
                                    <div className="mt-1.5 flex items-center justify-between">
                                        <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#111827] text-[6px] font-bold text-white">{d.owner}</span>
                                        <span className="flex items-center gap-0.5 text-[7px] font-medium text-[#94A3B8]">
                                            <CalendarDays className="h-2 w-2" /> {d.close}
                                        </span>
                                    </div>
                                    <div className="mt-1.5 flex items-center gap-1">
                                        <span className="h-0.5 flex-1 rounded-full bg-[#F1F5F9]">
                                            <span className="block h-0.5 rounded-full" style={{ width: `${d.prob}%`, background: col.color }} />
                                        </span>
                                        <span className="text-[7px] font-bold text-[#64748B]">{d.prob}%</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default PipelineScreen;
